import { render, staticRenderFns } from "./proyecto.vue?vue&type=template&id=771dea9c&scoped=true"
import script from "./proyecto.vue?vue&type=script&lang=js"
export * from "./proyecto.vue?vue&type=script&lang=js"
import style0 from "./proyecto.vue?vue&type=style&index=0&id=771dea9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771dea9c",
  null
  
)

export default component.exports